module.exports = __webpack_public_path__ + "img/equipment_logo_name@3x.ed1a1ea7.png";